// ---------------------------------------------------------------------------
// DisconnectBanner — SP-5f Task C2
// Alert shown when the live SSE stream is disconnected or reconnecting.
// ---------------------------------------------------------------------------

import { Button } from 'reactstrap';
import type { ConnectionStatus } from '../../hooks/useLiveStream';

export interface DisconnectBannerProps {
  status: ConnectionStatus;
  onRetry: () => void;
}

export function DisconnectBanner({ status, onRetry }: DisconnectBannerProps) {
  const reconnecting = status === 'reconnecting';
  return (
    <div
      role="alert"
      style={{
        padding: 16,
        marginBottom: 16,
        background: 'var(--vp-danger-soft, #FEE)',
        border: '1px solid var(--vp-danger, #b00020)',
        borderRadius: 'var(--vp-r-md, 8px)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <div style={{ flex: 1 }}>
        <strong>Connessione live persa</strong>
        <p style={{ margin: '4px 0 0' }}>
          {reconnecting
            ? 'Riconnessione in corso…'
            : 'Non riusciamo a ricevere aggiornamenti.'}
        </p>
      </div>
      <Button type="button" color="primary" size="sm" onClick={onRetry}>
        Riprova ora
      </Button>
    </div>
  );
}
